import { Route, Redirect } from "react-router-dom"

import CircularProgress from "@material-ui/core/CircularProgress"
import Box from "@material-ui/core/Box"

import { useAppSelector } from "common/hooks"
import { Role } from "common/types/user.type"
import { useEffect, useState } from "react"

export const ProtectedRoute = props => {
    const { user: currentUser } = useAppSelector(state => state.auth)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        window.setTimeout(() => {
            setIsLoading(false)
        }, 1000)
    }, [currentUser])

    if (isLoading && !currentUser) {
        return (
            <Box style={{ height: "100vh", display: "grid", placeContent: "center" }}>
                <CircularProgress />
            </Box>
        )
    }

    if (!currentUser) {
        return <Redirect to="/login" />
    }

    if (props.role) {
        const currentUserRole = Role[currentUser.role]
        if (currentUserRole === undefined || currentUserRole < props.role) {
            return <Redirect to="/" />
        }
    }

    return <Route {...props} />
}

export const PublicRoute = props => {
    const { user: currentUser } = useAppSelector(state => state.auth)
    return currentUser ? <Redirect to="/containers" /> : <Route {...props} />
}
